(ns hypnos.backoffice.tile.field.anatomy-nose
  "Field for the nose."
  (:require [clojure.string :as str]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn nose-field
  ([state]
   (nose-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/nose)]]
    [:div.field-body
     #_[:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/height)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 3
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/nose-height :value])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              old-value (get-in @state [:anatomy :anatomy/nose-height :value])
                              new-value (when-not (str/blank? val) (int val))
                              changed?  (or (get-in @state [:anatomy :anatomy/nose-height :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/nose-height :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:anatomy :anatomy/nose-height :dirty?]
                                 changed?)))
          :on-focus   (fn [_]
                        (swap! state assoc-in
                               [:anatomy :anatomy/nose-height :touched?]
                               true))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/width)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 3
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/nose-width])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/nose-width]
                                 new-value)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/length)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 3
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/nose-length])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/nose-length]
                                 new-value)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]]]))

(defn nare-clef-field
  ([state]
   (nare-clef-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal]
    [:div.field-body
     #_[:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/nare)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 3
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/nare-size :value])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              old-value (get-in @state [:anatomy :anatomy/nare-size :value])
                              new-value (when-not (str/blank? val) (int val))
                              changed?  (or (get-in @state [:anatomy :anatomy/nare-size :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/nare-size :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:anatomy :anatomy/nare-size :dirty?]
                                 changed?)))
          :on-focus   (fn [_]
                        (swap! state assoc-in
                               [:anatomy :anatomy/nare-size :touched?]
                               true))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]
     #_[:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/clef)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 3
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/clef-size :value])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              old-value (get-in @state [:anatomy :anatomy/clef-size :value])
                              new-value (when-not (str/blank? val) (int val))
                              changed?  (or (get-in @state [:anatomy :anatomy/clef-size :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/clef-size :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:anatomy :anatomy/clef-size :dirty?]
                                 changed?)))
          :on-focus   (fn [_]
                        (swap! state assoc-in
                               [:anatomy :anatomy/clef-size :touched?]
                               true))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/nose-to-clef)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 3
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/nose-to-clef])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/nose-to-clef :value]
                                 new-value)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]]]))
